import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  url = "https://niivsnes.humge.com";
  constructor(private http: HttpClient,private logService:LogService) {
   }

  getDocuments():Observable<any> {
    return this.http.get(this.url+'/api/getDocuments?token='+localStorage.getItem('token'));
  }

  editDocument(id):Observable<any> {
    return this.http.get(this.url+'/api/editDocument/'+id+'?token='+localStorage.getItem('token'));
  }

  getFilterDocuments(data):Observable<any> {
    return this.http.post(this.url+'/api/filterDocuments?token='+localStorage.getItem('token'),data);
  }

  getDocumentType():Observable<any> {
    return this.http.get(this.url+'/api/getDocumentType?token='+localStorage.getItem('token'));
  }
  
  getDocumentNumber(id):Observable<any> {
    return this.http.get(this.url+'/api/getDocumentNumber/'+id+'?token='+localStorage.getItem('token'));
  }

  getSubjects():Observable<any> {
    return this.http.get(this.url+'/api/getSubjects?token='+localStorage.getItem('token'));
  }

  subjectInfo(data){
    return this.http.get(this.url+'/api/subjectInfo/'+data+'?token='+localStorage.getItem('token'));
  }

  accountInfo(id){
    return this.http.get(this.url+'/api/accountInfo/'+id+'?token='+localStorage.getItem('token'));
  }

  getItems():Observable<any> {
    return this.http.get(this.url+'/api/items?token='+localStorage.getItem('token'));
  }

  getDocumentItems(id):Observable<any> {
    return this.http.get(this.url+'/api/documentItems/'+id+'?token='+localStorage.getItem('token'));
  }

  saveDoc(data): Observable<any> {
    return this.http.post(this.url+'/api/saveDocument?token='+localStorage.getItem('token') ,data); //acc docs
  }

  updateDoc(data,id): Observable<any> {
    return this.http.post(this.url+'/api/updateDocument/'+id+'?token='+localStorage.getItem('token') ,data); //acc docs
  }

  generateDoc(type,data): Observable<any> {
    return this.http.post(this.url+'/api/generateReqDoc/'+ type +'?token='+localStorage.getItem('token') ,data); //acc docs
  }

  generatedDocs(id): Observable<any> {
    return this.http.get(this.url+'/api/generatedDocs/'+ id+'?token='+localStorage.getItem('token')); //docIds
  }

  generateReqDoc(id,data): Observable<any> {
    return this.http.post(this.url+'/api/generateReq/'+ id +'?token='+localStorage.getItem('token') ,data); //request doc
  }

  generateReqProtocol(id,data): Observable<any> {
    return this.http.post(this.url+'/api/generateProtocol/'+ id +'?token='+localStorage.getItem('token') ,data); //request doc
  }



//protocols

getProtocols():Observable<any> {
  return this.http.get(this.url+'/api/getProtocols?token='+localStorage.getItem('token'));
}
getResults(id):Observable<any> {
  return this.http.get(this.url+'/api/getResults/'+id+'?token='+localStorage.getItem('token'));
}
updateResults(data):Observable<any> {
  return this.http.post(this.url+'/api/updateResults?token='+localStorage.getItem('token'),data);
}
acceptProtocol(data):Observable<any> {
  return this.http.post(this.url+'/api/acceptProtocol?token='+localStorage.getItem('token'),data);
}

declineProtocol(id):Observable<any> {
  return this.http.get(this.url+'/api/declineProtocol/'+id+'?token='+localStorage.getItem('token'));
}

checkLangPossibility(request,lng):Observable<any>{
  return this.http.get(this.url+'/api/checkLangPossibility/'+request+'/'+lng +'?token='+localStorage.getItem('token'));
}

}
